import { formatInTimeZone } from 'date-fns-tz';

export const SCHEDULING_TIMEZONE = 'America/New_York';

/** Parse API datetimes stored as naive UTC (or offset/Z strings). */
export function parseApiUtcDate(raw) {
  if (!raw) return null;
  const value = String(raw);
  const hasOffset = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(value);
  const d = new Date(hasOffset ? value : `${value}Z`);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatSchedulingTime(raw, pattern = 'PPp zzz') {
  const d = parseApiUtcDate(raw);
  if (!d) return '—';
  return formatInTimeZone(d, SCHEDULING_TIMEZONE, pattern);
}
